import React, { useState } from "react";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArchive,
  faDownload,
  faEnvelope,
  faEye,
  faMoneyBillTransfer,
  // faTrash,
  // faPrint,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import ReceiptDetailsPopup from "./ReceiptDetailsPopup";
import { toast } from "../../components/ui/use-toast";
import RefundIcon from "../../assets/images/refund.svg";
import axios from "axios";
import { API, get } from "../../config";
import { ClipboardList } from "lucide-react";

const ReceiptActionButton = ({
  id,
  item,
  setReceiptId,
  setReceiptItem,
  toggleShowUndo,
  toggleShowRefundHistory,
  handleSendEmail,
  toggleShowRefund,
  toggleShowUse,
  setLoading,
  trustId,
  toggleShowDelete,
  receiptAction = false,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  // const downloadLetter = (path) => {
  //   if (!path) {
  //     toast({
  //       variant: "destructive",
  //       description: "File does not exist.",
  //       duration: 3000,
  //     });
  //     return;
  //   }

  //   const link = document.createElement("a");
  //   link.href = path;
  //   link.target = "_blank"; // Opens in a new tab
  //   link.rel = "noopener noreferrer";

  //   // If you want to trigger download as well
  //   const filename = path.split("/").pop() || "file.pdf";
  //   link.setAttribute("download", filename);

  //   document.body.appendChild(link);
  //   link.click();
  //   link.remove();
  // };

  const downloadLetter = async () => {
    try {
      setLoading(true);
      const { data } = await get(
        `${API.RECEIPT_DOWNLOAD}/${id}?trust_id=${trustId ? trustId : ""}`,
      );
      let path = data?.data;
      if (path) {
        const response = await axios.get(`${path}`, {
          responseType: "blob",
        });
        const fileData = response.data;
        const url = window.URL.createObjectURL(new Blob([fileData]));
        var a = document.createElement("a");
        a.href = url;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File does not exist.");
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      // const errors = e.response?.data?.errors;
      // Object.keys(errors).forEach((key) => {
      //   toast.error(errors[key][0]);
      // });
    }
  };

  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        {receiptAction ? (
          item?.is_reversed === 1 || item?.archived ? (
            <></>
          ) : (
            <>
              <CustomTooltip message={"View"}>
                <span>
                  <FontAwesomeIcon
                    icon={faEye}
                    size="1x"
                    onClick={toggleShowModal}
                  />
                </span>
              </CustomTooltip>
              {item?.receipt_file && (
                <>
                  <span>/</span>
                  <CustomTooltip message={"Download"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faDownload}
                        size="1x"
                        onClick={() => {
                          downloadLetter(item?.receipt_file);
                        }}
                      />
                    </span>
                  </CustomTooltip>
                </>
              )}

              {item?.contact?.email !== null && (
                <>
                  <span>/</span>
                  <CustomTooltip message={"Email"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        size="1x"
                        onClick={() => {
                          !item?.is_reversed && handleSendEmail(item?.id);
                        }}
                        className={`${
                          item?.is_reversed
                            ? "opacity-50 cursor-not-allowed "
                            : ""
                        }`}
                      />
                    </span>
                  </CustomTooltip>
                </>
              )}
            </>
          )
        ) : (
          <>
            {item?.is_reversed === 1 ? (
              <>Reversed</>
            ) : item?.is_refund === 1 ? (
              <>
                {" "}
                <CustomTooltip message={"Refund History"}>
                  <span>
                    {/* <FontAwesomeIcon
                          icon={faMoneyBillTransfer}
                          size="1x"
                          onClick={() => {
                            toggleShowRefund();
                            setReceiptId(id);
                          }}
                        /> */}
                    <div className="h-4 w-4 dark:invert">
                      <ClipboardList
                        size={16}
                        onClick={() => {
                          toggleShowRefundHistory();
                          setReceiptId(id);
                          setReceiptItem(item);
                        }}
                      />
                    </div>
                  </span>
                </CustomTooltip>
                <span>/</span>
                <CustomTooltip
                  message={
                    item?.refunded_date
                      ? `Refunded - ${item?.refunded_date}`
                      : "Refunded"
                  }
                >
                  <span>Refunded</span>
                </CustomTooltip>
              </>
            ) : item?.is_disposed === 1 ? (
              <>Disposed</>
            ) : item?.archived === 1 ? (
              <>Revert</>
            ) : (
              <>
                {item?.is_reversed === 0 &&
                  item?.is_reconciled === 0 &&
                  item?.is_remaining_balance === 0 &&
                  item?.refund !== 1 &&
                  item?.allocation_date === item?.transaction_date && (
                    <>
                      {/* <span>/</span> */}
                      <CustomTooltip message={"Undo"}>
                        <span>
                          <FontAwesomeIcon
                            icon={faUndo}
                            size="1x"
                            onClick={() => {
                              toggleShowUndo();
                              setReceiptId(id);
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      {item?.is_refund_history === 1 && <span>/</span>}
                    </>
                  )}

                {item?.refund === 1 && (
                  <>
                    {item?.is_reconciled === 0 && (
                      <>
                        <CustomTooltip message={"Revert"}>
                          <span>
                            <FontAwesomeIcon
                              icon={faArchive}
                              size="1x"
                              onClick={() => {
                                toggleShowDelete();
                                setReceiptId(id);
                              }}
                            />
                          </span>
                        </CustomTooltip>
                        <span>/</span>
                      </>
                    )}
                  </>
                )}

                {item?.is_refund_history === 1 && (
                  <>
                    <CustomTooltip message={"Refund History"}>
                      <span>
                        <div className="h-4 w-4 dark:invert">
                          <ClipboardList
                            size={16}
                            onClick={() => {
                              toggleShowRefundHistory();
                              setReceiptId(id);
                              setReceiptItem(item);
                            }}
                          />
                        </div>
                      </span>
                    </CustomTooltip>
                    {item?.refund === 1 && <span>/</span>}
                  </>
                )}

                {item?.refund === 1 && (
                  <>
                    {/* <span>/</span> */}
                    <CustomTooltip message={"Refund"}>
                      <span>
                        <div className="h-4 w-4 dark:invert">
                          <img
                            width={20}
                            height={20}
                            src={RefundIcon}
                            alt=""
                            onClick={() => {
                              toggleShowRefund();
                              setReceiptId(id);
                              setReceiptItem(item);
                            }}
                          />
                        </div>
                      </span>
                    </CustomTooltip>
                    <span>/</span>
                    <CustomTooltip message={"Allocate"}>
                      <span>
                        <FontAwesomeIcon
                          icon={faMoneyBillTransfer}
                          size="1x"
                          onClick={() => {
                            toggleShowUse();
                            setReceiptId(id);
                            setReceiptItem(item);
                          }}
                        />
                      </span>
                    </CustomTooltip>
                  </>
                )}
              </>
            )}
          </>
        )}
      </span>
      {showView && (
        <ReceiptDetailsPopup
          showView={showView}
          setShowView={setShowView}
          data={item}
          type={item?.trust?.receipt_template_type}
        />
      )}
    </>
  );
};

export default ReceiptActionButton;
